import React from 'react';

const LogoSVG = ({file, width, height}) => {
  return (
      <img src={`../../../../assets/images/${file}`} alt={'Main Company Logo'} width={width} height={height}/>
  );
};

export default LogoSVG;
